import { render, staticRenderFns } from "./SU1TotalCompletedSurvey.vue?vue&type=template&id=496325ff&scoped=true"
import script from "./SU1TotalCompletedSurvey.vue?vue&type=script&lang=js"
export * from "./SU1TotalCompletedSurvey.vue?vue&type=script&lang=js"
import style0 from "./SU1TotalCompletedSurvey.vue?vue&type=style&index=0&id=496325ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496325ff",
  null
  
)

export default component.exports